import {
  WorldReady,
  MessageFormat,
  CurrencyFormat,
  PhoneNumberFormat,
} from '@paypalcorp/worldready'
import serverData from 'ppbl/utils/server-data'

const EMPTY_PLACEHOLDER_TEXT = '-'
const EMPTY_PLACEHOLDER_NUMBER = ''

export const getLocalizedText = (textId) => {
  const worldReadyLocale = serverData.locality.locale
  const worldReady = new WorldReady(worldReadyLocale)
  try {
    const messageFormatter = new MessageFormat(worldReady, {
      id: textId,
    })
    return messageFormatter.format()
  } catch (error) {
    return EMPTY_PLACEHOLDER_TEXT
  }
}

export const getCurrencyFormat = (value) => {
  const worldReadyLocale = serverData.locality.locale
  const worldReady = new WorldReady(worldReadyLocale)
  try {
    let currencyFormatter = new CurrencyFormat(worldReady, { currency: 'USD' })
    return currencyFormatter.format(value)
  } catch (error) {
    return EMPTY_PLACEHOLDER_NUMBER
  }
}

export const getCurrencyFormatNoTrailingZeroes = (value) => {
  const formatted = getCurrencyFormat(value)
  return formatted.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')
}

// A custom phone number formatter used for phone numbers starting with 0 or 1
export const customPhoneNumberFormatter = (phone) => {
  // regex to match and group the digits in the required format
  const match = phone.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`
  }
  return null
}

export const getPhoneNumberFormat = (phone) => {
  try {
    // custom handling for phone numbers starting with 0 or 1 as the worldready package does not format it correctly
    if (phone[0] === '1' || phone[0] === '0') {
      return customPhoneNumberFormatter(phone)
    }

    let phoneNumberFormatter = new PhoneNumberFormat({ phoneRegion: 'US' })
    return phoneNumberFormatter.formatAsTyped(phone)
  } catch (error) {
    return EMPTY_PLACEHOLDER_NUMBER
  }
}
